export default __webpack_public_path__ + "static/media/sign_up_4.8f99b580.webp";